import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/user/`;

const login = async (user) => {
    return await axios.post(API_URL + 'login', user);
};

const logout = async () => {
    return await axios.get(API_URL + 'logout');
};

const checkLoginStatus = async () => {
    return await axios.get(API_URL + 'loggedin');
};

const UserService = {
  login,
  logout,
  checkLoginStatus,
};
export default UserService;
